var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _g4, _path19, _path20, _path21, _path22, _g5, _g6, _path23, _g7, _path24, _path25, _path26, _path27, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 246,
    viewBox: "0 0 324 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.368 206.261L147.391 206.284L147.229 206.551C146.77 207.51 146.207 208.415 145.548 209.251C136.218 223.542 122.521 234.437 106.497 240.315C90.473 246.192 72.9794 246.738 56.6208 241.869C40.2622 237 25.9134 226.979 15.711 213.296C5.5085 199.613 -0.00197828 183.001 5.32755e-07 165.934C5.32755e-07 137.786 14.9257 113.207 37.0476 99.1506C51.0462 89.7641 83.7946 104.134 112.51 132.872C139.893 160.255 154.228 191.3 147.368 206.261Z",
    fill: "#F6BF3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.368 206.261L147.391 206.284L147.229 206.551C146.77 207.51 146.207 208.415 145.548 209.251C136.218 223.542 122.521 234.437 106.497 240.315C90.473 246.192 72.9794 246.738 56.6208 241.869C40.2622 237 25.9134 226.979 15.711 213.296C5.5085 199.613 -0.00197828 183.001 5.32755e-07 165.934C5.32755e-07 137.786 14.9257 113.207 37.0476 99.1506C51.0462 89.7641 83.7946 104.134 112.51 132.872C139.893 160.255 154.228 191.3 147.368 206.261Z",
    fill: "url(#paint0_radial_971_6614)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.368 206.261L147.391 206.284L147.229 206.551C146.77 207.51 146.207 208.415 145.548 209.251C136.218 223.542 122.521 234.437 106.497 240.315C90.473 246.192 72.9794 246.738 56.6208 241.869C40.2622 237 25.9134 226.979 15.711 213.296C5.5085 199.613 -0.00197828 183.001 5.32755e-07 165.934C5.32755e-07 137.786 14.9257 113.207 37.0476 99.1506C51.0462 89.7641 83.7946 104.134 112.51 132.872C139.893 160.255 154.228 191.3 147.368 206.261Z",
    fill: "url(#paint1_radial_971_6614)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.368 206.261L147.391 206.284L147.229 206.551C146.77 207.51 146.207 208.415 145.548 209.251C136.218 223.542 122.521 234.437 106.497 240.315C90.473 246.192 72.9794 246.738 56.6208 241.869C40.2622 237 25.9134 226.979 15.711 213.296C5.5085 199.613 -0.00197828 183.001 5.32755e-07 165.934C5.32755e-07 137.786 14.9257 113.207 37.0476 99.1506C51.0462 89.7641 83.7946 104.134 112.51 132.872C139.893 160.255 154.228 191.3 147.368 206.261Z",
    fill: "url(#paint2_radial_971_6614)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.427 206.261L176.416 206.284L176.566 206.551C177.03 207.524 177.609 208.428 178.258 209.251C187.589 223.542 201.286 234.437 217.31 240.315C233.334 246.192 250.827 246.738 267.186 241.869C283.544 237 297.893 226.979 308.096 213.296C318.298 199.613 323.809 183.001 323.807 165.934C323.807 137.786 309.344 111.967 287.234 97.9107C273.235 88.5358 239.908 104.145 211.18 132.861C183.797 160.255 169.567 191.3 176.427 206.261Z",
    fill: "#F7CC36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.427 206.261L176.416 206.284L176.566 206.551C177.03 207.524 177.609 208.428 178.258 209.251C187.589 223.542 201.286 234.437 217.31 240.315C233.334 246.192 250.827 246.738 267.186 241.869C283.544 237 297.893 226.979 308.096 213.296C318.298 199.613 323.809 183.001 323.807 165.934C323.807 137.786 309.344 111.967 287.234 97.9107C273.235 88.5358 239.908 104.145 211.18 132.861C183.797 160.255 169.567 191.3 176.427 206.261Z",
    fill: "url(#paint3_radial_971_6614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.427 206.261L176.416 206.284L176.566 206.551C177.03 207.524 177.609 208.428 178.258 209.251C187.589 223.542 201.286 234.437 217.31 240.315C233.334 246.192 250.827 246.738 267.186 241.869C283.544 237 297.893 226.979 308.096 213.296C318.298 199.613 323.809 183.001 323.807 165.934C323.807 137.786 309.344 111.967 287.234 97.9107C273.235 88.5358 239.908 104.145 211.18 132.861C183.797 160.255 169.567 191.3 176.427 206.261Z",
    fill: "url(#paint4_radial_971_6614)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.576 101.906C276.176 90.5058 243.426 104.773 214.427 133.773C185.428 162.772 171.16 195.522 182.56 206.921C193.96 218.321 226.71 204.054 255.709 175.055C284.709 146.055 298.976 113.305 287.576 101.906Z",
    stroke: "url(#paint5_linear_971_6614)",
    strokeWidth: 0.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.576 101.906C276.176 90.5058 243.426 104.773 214.427 133.773C185.428 162.772 171.16 195.522 182.56 206.921C193.96 218.321 226.71 204.054 255.709 175.055C284.709 146.055 298.976 113.305 287.576 101.906Z",
    fill: "url(#paint6_linear_971_6614)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.126 84.6146C106.987 85.7363 110.177 85.6755 112.993 84.4455C115.81 83.2154 118.022 80.9169 119.144 78.0556C124.15 65.2506 133.12 33.07 109.955 4.27324C108.021 1.89815 105.227 0.384857 102.181 0.0640411C99.1356 -0.256767 96.0869 0.640999 93.7013 2.56115C91.3156 4.48131 89.787 7.2677 89.4495 10.3114C89.112 13.3552 89.9931 16.4088 91.9001 18.8049C106.965 37.5315 101.715 58.9814 97.5552 69.5962C97.0001 71.0137 96.7297 72.5267 96.7595 74.0487C96.7893 75.5708 97.1187 77.072 97.7289 78.4667C98.339 79.8614 99.218 81.1222 100.316 82.1771C101.413 83.232 102.708 84.0602 104.126 84.6146Z",
    fill: "#FC28A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.126 84.6146C106.987 85.7363 110.177 85.6755 112.993 84.4455C115.81 83.2154 118.022 80.9169 119.144 78.0556C124.15 65.2506 133.12 33.07 109.955 4.27324C108.021 1.89815 105.227 0.384857 102.181 0.0640411C99.1356 -0.256767 96.0869 0.640999 93.7013 2.56115C91.3156 4.48131 89.787 7.2677 89.4495 10.3114C89.112 13.3552 89.9931 16.4088 91.9001 18.8049C106.965 37.5315 101.715 58.9814 97.5552 69.5962C97.0001 71.0137 96.7297 72.5267 96.7595 74.0487C96.7893 75.5708 97.1187 77.072 97.7289 78.4667C98.339 79.8614 99.218 81.1222 100.316 82.1771C101.413 83.232 102.708 84.0602 104.126 84.6146Z",
    fill: "url(#paint7_linear_971_6614)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.828 181.01C244.088 180.471 245.229 179.689 246.186 178.708C247.143 177.728 247.898 176.569 248.407 175.297C248.916 174.025 249.169 172.665 249.152 171.295C249.136 169.925 248.849 168.572 248.309 167.313C239.074 145.805 225.411 129.871 211.609 121.018C211.447 120.35 211.273 119.686 211.088 119.024C209.083 111.956 205.873 105.373 202.71 101.399C201.071 99.3271 198.707 97.9544 196.096 97.5577C193.485 97.161 190.82 97.7699 188.64 99.2614C186.461 100.753 184.928 103.016 184.352 105.594C183.775 108.171 184.199 110.871 185.536 113.149C184.496 113.239 183.463 113.39 182.442 113.601C173.612 115.409 167.087 121.597 164.434 130.659C162.232 138.157 162.927 145.457 166.647 151.437C170.239 157.242 175.987 160.661 181.758 161.982C192.257 164.358 205.56 160.093 210.821 147.3C217.427 154.114 223.974 163.523 229.131 175.54C230.222 178.082 232.278 180.086 234.847 181.112C237.415 182.138 240.286 182.101 242.828 181.01ZM184.365 140.451C188.294 144.855 193.682 139.385 192.373 134.692C186.845 130.659 181.051 136.256 184.377 140.439L184.365 140.451Z",
    fill: "url(#paint8_linear_971_6614)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.828 181.01C244.088 180.471 245.229 179.689 246.186 178.708C247.143 177.728 247.898 176.569 248.407 175.297C248.916 174.025 249.169 172.665 249.152 171.295C249.136 169.925 248.849 168.572 248.309 167.313C239.074 145.805 225.411 129.871 211.609 121.018C211.447 120.35 211.273 119.686 211.088 119.024C209.083 111.956 205.873 105.373 202.71 101.399C201.071 99.3271 198.707 97.9544 196.096 97.5577C193.485 97.161 190.82 97.7699 188.64 99.2614C186.461 100.753 184.928 103.016 184.352 105.594C183.775 108.171 184.199 110.871 185.536 113.149C184.496 113.239 183.463 113.39 182.442 113.601C173.612 115.409 167.087 121.597 164.434 130.659C162.232 138.157 162.927 145.457 166.647 151.437C170.239 157.242 175.987 160.661 181.758 161.982C192.257 164.358 205.56 160.093 210.821 147.3C217.427 154.114 223.974 163.523 229.131 175.54C230.222 178.082 232.278 180.086 234.847 181.112C237.415 182.138 240.286 182.101 242.828 181.01ZM184.365 140.451C188.294 144.855 193.682 139.385 192.373 134.692C186.845 130.659 181.051 136.256 184.377 140.439L184.365 140.451Z",
    fill: "url(#paint9_linear_971_6614)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.828 181.01C244.088 180.471 245.229 179.689 246.186 178.708C247.143 177.728 247.898 176.569 248.407 175.297C248.916 174.025 249.169 172.665 249.152 171.295C249.136 169.925 248.849 168.572 248.309 167.313C239.074 145.805 225.411 129.871 211.609 121.018C211.447 120.35 211.273 119.686 211.088 119.024C209.083 111.956 205.873 105.373 202.71 101.399C201.071 99.3271 198.707 97.9544 196.096 97.5577C193.485 97.161 190.82 97.7699 188.64 99.2614C186.461 100.753 184.928 103.016 184.352 105.594C183.775 108.171 184.199 110.871 185.536 113.149C184.496 113.239 183.463 113.39 182.442 113.601C173.612 115.409 167.087 121.597 164.434 130.659C162.232 138.157 162.927 145.457 166.647 151.437C170.239 157.242 175.987 160.661 181.758 161.982C192.257 164.358 205.56 160.093 210.821 147.3C217.427 154.114 223.974 163.523 229.131 175.54C230.222 178.082 232.278 180.086 234.847 181.112C237.415 182.138 240.286 182.101 242.828 181.01ZM184.365 140.451C188.294 144.855 193.682 139.385 192.373 134.692C186.845 130.659 181.051 136.256 184.377 140.439L184.365 140.451Z",
    fill: "url(#paint10_radial_971_6614)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.828 181.01C244.088 180.471 245.229 179.689 246.186 178.708C247.143 177.728 247.898 176.569 248.407 175.297C248.916 174.025 249.169 172.665 249.152 171.295C249.136 169.925 248.849 168.572 248.309 167.313C239.074 145.805 225.411 129.871 211.609 121.018C211.447 120.35 211.273 119.686 211.088 119.024C209.083 111.956 205.873 105.373 202.71 101.399C201.071 99.3271 198.707 97.9544 196.096 97.5577C193.485 97.161 190.82 97.7699 188.64 99.2614C186.461 100.753 184.928 103.016 184.352 105.594C183.775 108.171 184.199 110.871 185.536 113.149C184.496 113.239 183.463 113.39 182.442 113.601C173.612 115.409 167.087 121.597 164.434 130.659C162.232 138.157 162.927 145.457 166.647 151.437C170.239 157.242 175.987 160.661 181.758 161.982C192.257 164.358 205.56 160.093 210.821 147.3C217.427 154.114 223.974 163.523 229.131 175.54C230.222 178.082 232.278 180.086 234.847 181.112C237.415 182.138 240.286 182.101 242.828 181.01ZM184.365 140.451C188.294 144.855 193.682 139.385 192.373 134.692C186.845 130.659 181.051 136.256 184.377 140.439L184.365 140.451Z",
    fill: "url(#paint11_radial_971_6614)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.843 3.57826C168.641 3.57826 173.342 8.27881 173.342 14.0772C173.342 19.8756 168.641 24.5762 162.843 24.5762C157.044 24.5762 152.344 19.8756 152.344 14.0772C152.344 8.27881 157.044 3.57826 162.843 3.57826Z",
    fill: "url(#paint12_radial_971_6614)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.427 50.2931C203.225 50.2931 207.926 54.9937 207.926 60.7921C207.926 66.5905 203.225 71.291 197.427 71.291C191.628 71.291 186.928 66.5905 186.928 60.7921C186.928 54.9937 191.628 50.2931 197.427 50.2931Z",
    fill: "url(#paint13_radial_971_6614)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.056 15.5294C248.854 15.5294 253.555 20.23 253.555 26.0284C253.555 31.8268 248.854 36.5273 243.056 36.5273C237.257 36.5273 232.557 31.8268 232.557 26.0284C232.557 20.23 237.257 15.5294 243.056 15.5294Z",
    fill: "url(#paint14_radial_971_6614)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.579 97.4864C121.801 97.4864 126.035 101.72 126.035 106.942C126.035 112.165 121.801 116.398 116.579 116.398C111.357 116.398 107.123 112.165 107.123 106.942C107.123 101.72 111.357 97.4864 116.579 97.4864Z",
    fill: "url(#paint15_radial_971_6614)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6692 29.3003C86.3988 29.3003 90.2329 33.1344 90.2329 37.864C90.2329 42.5936 86.3988 46.4277 81.6692 46.4277C76.9396 46.4277 73.1055 42.5936 73.1055 37.864C73.1055 33.1344 76.9396 29.3003 81.6692 29.3003Z",
    fill: "url(#paint16_radial_971_6614)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6692 29.3003C86.3988 29.3003 90.2329 33.1344 90.2329 37.864C90.2329 42.5936 86.3988 46.4277 81.6692 46.4277C76.9396 46.4277 73.1055 42.5936 73.1055 37.864C73.1055 33.1344 76.9396 29.3003 81.6692 29.3003Z",
    fill: "url(#paint17_radial_971_6614)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7325 101.894C49.1322 90.4941 81.8821 104.761 110.881 133.761C139.881 162.76 154.148 195.51 142.748 206.91C131.349 218.309 98.5988 204.042 69.5995 175.043C40.6001 146.043 26.3328 113.294 37.7325 101.894Z",
    stroke: "url(#paint18_linear_971_6614)",
    strokeWidth: 0.3
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7325 101.894C49.1322 90.4941 81.8821 104.761 110.881 133.761C139.881 162.76 154.148 195.51 142.748 206.91C131.349 218.309 98.5988 204.042 69.5995 175.043C40.6001 146.043 26.3328 113.294 37.7325 101.894Z",
    fill: "url(#paint19_linear_971_6614)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7708 152.973C55.4756 159.544 61.0496 166.242 67.3768 172.789C69.3931 168.675 71.3631 164.121 73.1709 159.3C78.1654 145.939 82.3951 129.275 82.9861 111.893C83.6814 91.7988 77.0298 73.5937 68.7673 59.2822C60.5281 44.9939 50.2493 33.7996 42.4852 27.5304C40.0886 25.6879 37.0668 24.8549 34.0646 25.209C31.0624 25.5632 28.3174 27.0765 26.4154 29.4261C24.5133 31.7758 23.6047 34.7757 23.8834 37.7858C24.1621 40.796 25.606 43.5781 27.9072 45.5385C33.4232 50 41.8478 58.9809 48.6849 70.8473C55.5104 82.6673 60.3195 96.5847 59.8328 111.093C59.3345 125.393 55.8117 139.542 51.4545 151.189L50.7708 152.973Z",
    fill: "#24A4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7708 152.973C55.4756 159.544 61.0496 166.242 67.3768 172.789C69.3931 168.675 71.3631 164.121 73.1709 159.3C78.1654 145.939 82.3951 129.275 82.9861 111.893C83.6814 91.7988 77.0298 73.5937 68.7673 59.2822C60.5281 44.9939 50.2493 33.7996 42.4852 27.5304C40.0886 25.6879 37.0668 24.8549 34.0646 25.209C31.0624 25.5632 28.3174 27.0765 26.4154 29.4261C24.5133 31.7758 23.6047 34.7757 23.8834 37.7858C24.1621 40.796 25.606 43.5781 27.9072 45.5385C33.4232 50 41.8478 58.9809 48.6849 70.8473C55.5104 82.6673 60.3195 96.5847 59.8328 111.093C59.3345 125.393 55.8117 139.542 51.4545 151.189L50.7708 152.973Z",
    fill: "url(#paint20_linear_971_6614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7708 152.973C55.4756 159.544 61.0496 166.242 67.3768 172.789C69.3931 168.675 71.3631 164.121 73.1709 159.3C78.1654 145.939 82.3951 129.275 82.9861 111.893C83.6814 91.7988 77.0298 73.5937 68.7673 59.2822C60.5281 44.9939 50.2493 33.7996 42.4852 27.5304C40.0886 25.6879 37.0668 24.8549 34.0646 25.209C31.0624 25.5632 28.3174 27.0765 26.4154 29.4261C24.5133 31.7758 23.6047 34.7757 23.8834 37.7858C24.1621 40.796 25.606 43.5781 27.9072 45.5385C33.4232 50 41.8478 58.9809 48.6849 70.8473C55.5104 82.6673 60.3195 96.5847 59.8328 111.093C59.3345 125.393 55.8117 139.542 51.4545 151.189L50.7708 152.973Z",
    fill: "url(#paint21_radial_971_6614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7708 152.973C55.4756 159.544 61.0496 166.242 67.3768 172.789C69.3931 168.675 71.3631 164.121 73.1709 159.3C78.1654 145.939 82.3951 129.275 82.9861 111.893C83.6814 91.7988 77.0298 73.5937 68.7673 59.2822C60.5281 44.9939 50.2493 33.7996 42.4852 27.5304C40.0886 25.6879 37.0668 24.8549 34.0646 25.209C31.0624 25.5632 28.3174 27.0765 26.4154 29.4261C24.5133 31.7758 23.6047 34.7757 23.8834 37.7858C24.1621 40.796 25.606 43.5781 27.9072 45.5385C33.4232 50 41.8478 58.9809 48.6849 70.8473C55.5104 82.6673 60.3195 96.5847 59.8328 111.093C59.3345 125.393 55.8117 139.542 51.4545 151.189L50.7708 152.973Z",
    fill: "url(#paint22_radial_971_6614)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 174.961L69.6005 175.054C75.2783 180.75 81.3292 186.061 87.7129 190.953C89.3932 187.013 91.7688 181.903 94.5964 176.63C98.49 169.353 102.824 162.516 106.915 158.089C109.499 155.284 111.759 154.902 118.897 154.972L119.824 154.983C126.592 155.076 138.052 155.215 147.682 145.4C157.439 135.805 157.115 124.773 156.918 118.028C156.895 117.171 156.872 116.371 156.872 115.664V90.8886C156.872 90.1209 157.024 89.3608 157.321 88.6526C157.617 87.9444 158.051 87.3021 158.598 86.7632L165.91 79.5553C168.1 77.3978 169.343 74.4587 169.366 71.3847C169.389 68.3107 168.19 65.3535 166.032 63.1637C163.875 60.9739 160.936 59.7309 157.862 59.7081C154.788 59.6853 151.83 60.8845 149.641 63.0421C141.645 70.1456 133.533 78.9643 133.765 93.1367L133.695 115.664C133.695 116.754 133.718 117.82 133.73 118.747V118.839C133.741 119.836 133.765 120.682 133.753 121.493C133.753 123.116 133.684 124.205 133.533 125.074C133.315 126.567 132.556 127.928 131.401 128.898L131.285 129.014L131.169 129.13C128.805 131.575 126.742 131.876 119.117 131.795H118.793C111.631 131.726 99.7879 131.61 89.8684 142.398C83.7961 148.98 78.3612 157.834 74.1547 165.691C72.5296 168.742 70.9801 171.833 69.5078 174.961Z",
    fill: "#FA3F99"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 174.961L69.6005 175.054C75.2783 180.75 81.3292 186.061 87.7129 190.953C89.3932 187.013 91.7688 181.903 94.5964 176.63C98.49 169.353 102.824 162.516 106.915 158.089C109.499 155.284 111.759 154.902 118.897 154.972L119.824 154.983C126.592 155.076 138.052 155.215 147.682 145.4C157.439 135.805 157.115 124.773 156.918 118.028C156.895 117.171 156.872 116.371 156.872 115.664V90.8886C156.872 90.1209 157.024 89.3608 157.321 88.6526C157.617 87.9444 158.051 87.3021 158.598 86.7632L165.91 79.5553C168.1 77.3978 169.343 74.4587 169.366 71.3847C169.389 68.3107 168.19 65.3535 166.032 63.1637C163.875 60.9739 160.936 59.7309 157.862 59.7081C154.788 59.6853 151.83 60.8845 149.641 63.0421C141.645 70.1456 133.533 78.9643 133.765 93.1367L133.695 115.664C133.695 116.754 133.718 117.82 133.73 118.747V118.839C133.741 119.836 133.765 120.682 133.753 121.493C133.753 123.116 133.684 124.205 133.533 125.074C133.315 126.567 132.556 127.928 131.401 128.898L131.285 129.014L131.169 129.13C128.805 131.575 126.742 131.876 119.117 131.795H118.793C111.631 131.726 99.7879 131.61 89.8684 142.398C83.7961 148.98 78.3612 157.834 74.1547 165.691C72.5296 168.742 70.9801 171.833 69.5078 174.961Z",
    fill: "url(#paint23_radial_971_6614)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 174.961L69.6005 175.054C75.2783 180.75 81.3292 186.061 87.7129 190.953C89.3932 187.013 91.7688 181.903 94.5964 176.63C98.49 169.353 102.824 162.516 106.915 158.089C109.499 155.284 111.759 154.902 118.897 154.972L119.824 154.983C126.592 155.076 138.052 155.215 147.682 145.4C157.439 135.805 157.115 124.773 156.918 118.028C156.895 117.171 156.872 116.371 156.872 115.664V90.8886C156.872 90.1209 157.024 89.3608 157.321 88.6526C157.617 87.9444 158.051 87.3021 158.598 86.7632L165.91 79.5553C168.1 77.3978 169.343 74.4587 169.366 71.3847C169.389 68.3107 168.19 65.3535 166.032 63.1637C163.875 60.9739 160.936 59.7309 157.862 59.7081C154.788 59.6853 151.83 60.8845 149.641 63.0421C141.645 70.1456 133.533 78.9643 133.765 93.1367L133.695 115.664C133.695 116.754 133.718 117.82 133.73 118.747V118.839C133.741 119.836 133.765 120.682 133.753 121.493C133.753 123.116 133.684 124.205 133.533 125.074C133.315 126.567 132.556 127.928 131.401 128.898L131.285 129.014L131.169 129.13C128.805 131.575 126.742 131.876 119.117 131.795H118.793C111.631 131.726 99.7879 131.61 89.8684 142.398C83.7961 148.98 78.3612 157.834 74.1547 165.691C72.5296 168.742 70.9801 171.833 69.5078 174.961Z",
    fill: "url(#paint24_radial_971_6614)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 174.961L69.6005 175.054C75.2783 180.75 81.3292 186.061 87.7129 190.953C89.3932 187.013 91.7688 181.903 94.5964 176.63C98.49 169.353 102.824 162.516 106.915 158.089C109.499 155.284 111.759 154.902 118.897 154.972L119.824 154.983C126.592 155.076 138.052 155.215 147.682 145.4C157.439 135.805 157.115 124.773 156.918 118.028C156.895 117.171 156.872 116.371 156.872 115.664V90.8886C156.872 90.1209 157.024 89.3608 157.321 88.6526C157.617 87.9444 158.051 87.3021 158.598 86.7632L165.91 79.5553C168.1 77.3978 169.343 74.4587 169.366 71.3847C169.389 68.3107 168.19 65.3535 166.032 63.1637C163.875 60.9739 160.936 59.7309 157.862 59.7081C154.788 59.6853 151.83 60.8845 149.641 63.0421C141.645 70.1456 133.533 78.9643 133.765 93.1367L133.695 115.664C133.695 116.754 133.718 117.82 133.73 118.747V118.839C133.741 119.836 133.765 120.682 133.753 121.493C133.753 123.116 133.684 124.205 133.533 125.074C133.315 126.567 132.556 127.928 131.401 128.898L131.285 129.014L131.169 129.13C128.805 131.575 126.742 131.876 119.117 131.795H118.793C111.631 131.726 99.7879 131.61 89.8684 142.398C83.7961 148.98 78.3612 157.834 74.1547 165.691C72.5296 168.742 70.9801 171.833 69.5078 174.961Z",
    fill: "url(#paint25_radial_971_6614)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.998 110.039V90.5708C147.998 86.0861 149.736 81.7637 152.854 78.5306L158.497 72.667",
    stroke: "#FF5CAC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.045 156.393C277.619 148.86 282.185 141.838 285.337 134.989C280.261 126.761 275.626 116.529 273.389 105.949C269.623 88.1957 272.161 68.5189 289.717 50.0936C290.767 48.9918 291.59 47.694 292.139 46.2742C292.687 44.8545 292.95 43.3407 292.914 41.8191C292.877 40.2975 292.541 38.7981 291.925 37.4063C291.309 36.0146 290.425 34.7578 289.323 33.7078C288.222 32.6578 286.924 31.835 285.504 31.2865C284.084 30.7381 282.57 30.4746 281.049 30.5112C279.527 30.5478 278.028 30.8837 276.636 31.4998C275.244 32.1158 273.988 33 272.938 34.1018C249.355 58.8427 245.612 86.6545 250.711 110.746C254.535 128.824 263.284 144.793 272.045 156.393Z",
    fill: "#2BBAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.045 156.393C277.619 148.86 282.185 141.838 285.337 134.989C280.261 126.761 275.626 116.529 273.389 105.949C269.623 88.1957 272.161 68.5189 289.717 50.0936C290.767 48.9918 291.59 47.694 292.139 46.2742C292.687 44.8545 292.95 43.3407 292.914 41.8191C292.877 40.2975 292.541 38.7981 291.925 37.4063C291.309 36.0146 290.425 34.7578 289.323 33.7078C288.222 32.6578 286.924 31.835 285.504 31.2865C284.084 30.7381 282.57 30.4746 281.049 30.5112C279.527 30.5478 278.028 30.8837 276.636 31.4998C275.244 32.1158 273.988 33 272.938 34.1018C249.355 58.8427 245.612 86.6545 250.711 110.746C254.535 128.824 263.284 144.793 272.045 156.393Z",
    fill: "url(#paint26_linear_971_6614)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 156.393C277.619 148.86 282.185 141.838 285.337 134.989C280.261 126.761 275.626 116.529 273.389 105.949C269.623 88.1957 272.161 68.5189 289.717 50.0936C290.767 48.9918 291.59 47.694 292.139 46.2742C292.687 44.8545 292.95 43.3407 292.914 41.8191C292.877 40.2975 292.541 38.7981 291.925 37.4063C291.309 36.0146 290.425 34.7578 289.323 33.7078C288.222 32.6578 286.924 31.835 285.504 31.2865C284.084 30.7381 282.57 30.4746 281.049 30.5112C279.527 30.5478 278.028 30.8837 276.636 31.4998C275.244 32.1158 273.988 33 272.938 34.1018C249.355 58.8427 245.612 86.6545 250.711 110.746C254.535 128.824 263.284 144.793 272.045 156.393Z",
    fill: "url(#paint27_radial_971_6614)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.566 123.449C264.547 110.169 255.763 75.5666 284.884 43.4092",
    stroke: "url(#paint28_linear_971_6614)",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M212.733 121.752C212.36 121.505 211.986 121.262 211.609 121.022C211.446 120.355 211.272 119.69 211.087 119.029C209.082 111.96 205.872 105.378 202.709 101.403C201.07 99.3314 198.707 97.9588 196.095 97.5621C193.484 97.1654 190.82 97.7742 188.64 99.2657C186.46 100.757 184.927 103.02 184.351 105.598C183.775 108.175 184.198 110.876 185.535 113.153L185.211 113.188C191.086 113.397 204.517 116.618 211.875 121.277C212.152 121.452 212.438 121.61 212.733 121.752Z",
    fill: "#2A82D3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M212.733 121.752C212.36 121.505 211.986 121.262 211.609 121.022C211.446 120.355 211.272 119.69 211.087 119.029C209.082 111.96 205.872 105.378 202.709 101.403C201.07 99.3314 198.707 97.9588 196.095 97.5621C193.484 97.1654 190.82 97.7742 188.64 99.2657C186.46 100.757 184.927 103.02 184.351 105.598C183.775 108.175 184.198 110.876 185.535 113.153L185.211 113.188C191.086 113.397 204.517 116.618 211.875 121.277C212.152 121.452 212.438 121.61 212.733 121.752Z",
    fill: "url(#paint29_radial_971_6614)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.733 121.752C212.36 121.505 211.986 121.262 211.609 121.022C211.446 120.355 211.272 119.69 211.087 119.029C209.082 111.96 205.872 105.378 202.709 101.403C201.07 99.3314 198.707 97.9588 196.095 97.5621C193.484 97.1654 190.82 97.7742 188.64 99.2657C186.46 100.757 184.927 103.02 184.351 105.598C183.775 108.175 184.198 110.876 185.535 113.153L185.211 113.188C191.086 113.397 204.517 116.618 211.875 121.277C212.152 121.452 212.438 121.61 212.733 121.752Z",
    fill: "url(#paint30_radial_971_6614)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.809 147.303C205.548 160.096 192.244 164.361 181.745 161.973C178.655 161.306 175.727 160.031 173.133 158.223C170.539 156.414 168.33 154.109 166.634 151.44C164.03 147.173 162.842 142.192 163.239 137.209H183.426C183.341 137.785 183.38 138.372 183.54 138.931C183.7 139.491 183.977 140.01 184.353 140.454C188.281 144.858 193.67 139.388 192.36 134.695C196.474 136.549 205.977 142.331 210.809 147.303Z",
    fill: "url(#paint31_radial_971_6614)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.338 123.804C191.17 122.819 181.158 123.225 176.43 133.075C170.462 145.509 186.732 159.299 200.29 146.239",
    stroke: "url(#paint32_linear_971_6614)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_971_6614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.05 170.539C239.678 162.566 228.646 138.81 208.656 126.353",
    stroke: "url(#paint33_linear_971_6614)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_971_6614",
    x: 174.469,
    y: 95.1882,
    width: 149.338,
    height: 149.972,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.698039 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_971_6614",
    x: 178.183,
    y: 97.529,
    width: 113.769,
    height: 113.769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_971_6614",
    x: 33.5562,
    y: 97.7174,
    width: 113.368,
    height: 113.369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_971_6614",
    x: 23.834,
    y: 25.1292,
    width: 59.3512,
    height: 147.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_971_6614",
    x: 147.199,
    y: 71.867,
    width: 12.0984,
    height: 38.972,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_971_6614",
    x: 248.717,
    y: 30.5078,
    width: 44.5012,
    height: 126.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.329412 0 0 0 0 0.6 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_971_6614",
    x: 263.815,
    y: 42.4591,
    width: 22.0187,
    height: 81.9401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.325,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_971_6614",
    x: 174.16,
    y: 122.442,
    width: 27.1289,
    height: 30.0732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_971_6614",
    x: 207.656,
    y: 125.353,
    width: 36.3945,
    height: 46.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_971_6614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.835 194.788) rotate(132.541) scale(83.5546 60.6397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE94C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE94C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8863 245.141) rotate(-61.118) scale(155.945 157.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#B9706D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9706D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.172 165.818) rotate(-176.876) scale(106.337 106.502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#F3C893",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.439 157.868) rotate(47.8156) scale(86.7646 72.3454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE76D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.419 220.885) rotate(-27.79) scale(35.1213 35.1758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6BE6F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_6614",
    x1: 284.217,
    y1: 119.883,
    x2: 237.911,
    y2: 57.1082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB43E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_971_6614",
    x1: 250.35,
    y1: 136.132,
    x2: 319.443,
    y2: 28.7566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#572943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2C30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_971_6614",
    x1: 114.868,
    y1: 94.8354,
    x2: 130.802,
    y2: 34.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9136C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_971_6614",
    x1: 232.92,
    y1: 165.088,
    x2: 174.979,
    y2: 97.4471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#1DA2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_971_6614",
    x1: 251.751,
    y1: 174.15,
    x2: 239.804,
    y2: 164.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8CBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.652 170.163) rotate(-119.705) scale(65.0398 42.1408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#3165CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3165CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.521 133.313) rotate(168.317) scale(74.2467 72.643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#2471AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#2471AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.181 16.9859) rotate(-130.855) scale(17.715 17.715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43C7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D64CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.326 64.6274) rotate(-140.042) scale(14.8645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF48A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB1D93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.468 28.8319) rotate(-144.498) scale(16.6809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97654"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.218 103.35) rotate(96.843) scale(13.6774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46518"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.3464 39.0707) rotate(-138.621) scale(10.1349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8AC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A437"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.2774 36.4522) rotate(25.755) scale(11.4592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#EB9530",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_971_6614",
    x1: 72.9672,
    y1: 193.029,
    x2: 119.272,
    y2: 130.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EABE3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976061"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_971_6614",
    x1: 142.757,
    y1: 206.918,
    x2: 37.7325,
    y2: 101.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_971_6614",
    x1: 27.096,
    y1: 21.9217,
    x2: 48.0012,
    y2: 41.1698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3067D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3067D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8874 117.977) rotate(5.85598) scale(61.4291 131.425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#47CEFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CEFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1784 150.656) rotate(-16.44) scale(17.4938 37.0728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1569A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1569A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4993 180.301) rotate(-63.941) scale(77.7596 19.5968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80963",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.369 149.096) rotate(-92.782) scale(73.8063 30.7611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#A80963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80963",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.548 89.4594) rotate(83.904) scale(43.4925 18.8299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80963",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_971_6614",
    x1: 287.237,
    y1: 150.598,
    x2: 270.817,
    y2: 126.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184E8C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(292.916 61.8788) rotate(-164.748) scale(17.8954 58.8225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BDCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_971_6614",
    x1: 284.884,
    y1: 43.4092,
    x2: 274.826,
    y2: 123.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BDAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.251 119.11) rotate(-76.1713) scale(12.1206 39.7578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#1E58A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E58A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.377 114.034) rotate(-163.015) scale(28.5127 40.1157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E58A8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E58A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_971_6614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.328 131.867) rotate(92.629) scale(17.7632 14.6023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#3258A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3258A2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_971_6614",
    x1: 184.762,
    y1: 155.104,
    x2: 187.01,
    y2: 123.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_971_6614",
    x1: 240.883,
    y1: 170.527,
    x2: 213.767,
    y2: 119.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B4E2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c2d41996c1085b1ab11ce662c2f98ab5.svg";
export { ForwardRef as ReactComponent };